export default {
  blocks: [],
  block: {}
}



// WEBPACK FOOTER //
// ./src/components/block/store/state.js